export default {
    "bulk_assg_altype_title": "Bulk Assign Alert Types",
    "bulk_assg_altype_warning_message": "No data to add",
    "bulk_assg_altype_error_message": "Device models have not been edited",
    "bulk_assg_altype_success_message": "The devices models have been edited",
    "bulk_assg_altype_from_device_model": "From Device Model",
    "bulk_assg_altype_add": "Add",
}   